export default Object.freeze({
  poi: 12,
  poa: 11,
})
